import React from 'react';
import { Breadcrumb as SemanticBreadcrumb } from 'semantic-ui-react';
import BreadcrumbItem from './BreadcrumbItem';

const Breadcrumb = ({ segments, onNavigate }) => (
  <SemanticBreadcrumb as="span" className="aridhia-folder-breadcrumbs">
    {segments.map((item, index) => (
      <BreadcrumbItem
        index={index}
        item={item}
        key={item.id ?? item.messageId ?? item.icon ?? `ellipsis-${index}`}
        length={segments.length}
        onNavigate={onNavigate}
        segments={segments}
      />
    ))}
  </SemanticBreadcrumb>
);

export default Breadcrumb;
